import { render, staticRenderFns } from "./UpdateMyProfile.vue?vue&type=template&id=1bebb176&lang=pug&"
import script from "./UpdateMyProfile.vue?vue&type=script&lang=js&"
export * from "./UpdateMyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports